import {
  useRealEstatePropertyForm,
  useCreateRealEstatePropertyService,
  getCreateRealEstateServiceInputFromForm,
} from '../../RealEstateProperty';
import { useSideOverContext } from '../components';
import { useClientContext } from '../../ClientContext';
import { RealEstateType } from '../../generated/graphql';
import { RealEstateFormSideOverPage, RealEstateFormSideOverPageProps } from './RealEstateFormSideOverPage';

interface CreateRealEstateSideOverImplementationPageProps
  extends Pick<RealEstateFormSideOverPageProps, 'formVisibilityOptions'> {
  exitRoute: string | undefined;
  realEstateType: RealEstateType;
  successExitRoute: string | undefined;
}

export function CreateRealEstateSideOverImplementationPage({
  exitRoute,
  realEstateType,
  successExitRoute,
  formVisibilityOptions,
}: CreateRealEstateSideOverImplementationPageProps) {
  const { closeSideOver } = useSideOverContext();
  const { firmID, clientID, householdID } = useClientContext();
  const { createRealEstatePropertyService } = useCreateRealEstatePropertyService();

  const useRealEstatePropertyFormReturn = useRealEstatePropertyForm({
    householdID,
    handleSubmit: (data) => {
      createRealEstatePropertyService.mutate(getCreateRealEstateServiceInputFromForm(data), {
        onSuccess: () => {
          closeSideOver(successExitRoute);
        },
      });
    },
    defaultValueOverrides: { realEstateType },
  });

  return (
    <RealEstateFormSideOverPage
      firmID={firmID}
      exit={exitRoute}
      clientID={clientID}
      realEstateType={realEstateType}
      formVisibilityOptions={formVisibilityOptions}
      isLoading={createRealEstatePropertyService.isLoading}
      useRealEstateFormReturn={useRealEstatePropertyFormReturn}
    />
  );
}
